import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import {
    ProductCardComponent, SubscriptionCardComponent, LicensesCardComponent,
    CardComponent
} from '../ui-components/';

import { CoreLibModule } from './core-lib.module';
import { ModalLibModule } from './modal-lib.module';
import { ChartLibModule } from './chart-lib.module';

@NgModule({
    imports: [CommonModule, RouterModule, ReactiveFormsModule, ModalLibModule, CoreLibModule, ChartLibModule],
    declarations: [
        ProductCardComponent,
        SubscriptionCardComponent,
        LicensesCardComponent,
        CardComponent
    ],
    exports: [
        ProductCardComponent,
        SubscriptionCardComponent,
        LicensesCardComponent,
        CardComponent
    ]
})
export class CardLibModule { }
